import Alpine from 'alpinejs';
import Plyr from 'plyr';
import VideoPlayer from '../interfaces/VideoPlayer';

export default function initVideoBanner() {
  Alpine.data(
    'videoBanner',
    (): VideoPlayer => ({
      player: null,
      isPlaying: false,
      playerElement: null,
      modalId: null,
      videoId: null,
      isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent || ''),
      init() {
        document.addEventListener('DOMContentLoaded', () => {
          if (!window.verifyCookies || window.verifyCookies()) {
            this.initVideo();
          }
        });
      },
      initVideo() {
        // @ts-ignore
        this.playerElement = this.$el.querySelector('.plyr__video-embed[data-player]');

        this.player = null;
        this.isPlaying = false;
      },
      onToggle() {
        if (this.isIOS) {
          this.openInYT();
        } else if (!this.player) {
          this.createIframe();
        } else {
          this.toggleStatus();
        }
      },
      createIframe() {
        if (this.playerElement) {
          const { id, poster, host } = this.playerElement.dataset;

          if (id && poster && host) {
            const iframeEl = document.createElement('iframe');
            iframeEl.src = `https://www.youtube.com/embed/${id}&modestbranding=1
            &rel=0&showinfo=0&controls=0&enablejsapi=1&mute=1&loop=1&playlist=${id}`;
            iframeEl.setAttribute('data-consent', 'analytics');
            iframeEl.setAttribute('data-poster', poster);
            iframeEl.setAttribute('allowfullscreen', '');
            iframeEl.setAttribute('allow', 'autoplay');
            iframeEl.title = 'Play video';
            iframeEl.className = 'position-absolute top-0 start-0 w-100 h-100';

            this.playerElement.appendChild(iframeEl);

            iframeEl.addEventListener('load', async () => {
              this.initVideoPlayer();
            });
          }
        }
      },
      toggleStatus() {
        if (this.isPlaying) {
          this.pause();
        } else {
          this.play();
        }
      },
      play() {
        if (this.player) {
          this.player.play();
          this.isPlaying = true;
        }
      },
      pause() {
        if (this.player) {
          this.player.pause();
          this.isPlaying = false;
        }
      },
      async initVideoPlayer() {
        if (this.playerElement) {
          let aspectRatio = '16:9';
          if (window.matchMedia('(max-width: 550px)').matches) {
            aspectRatio = '1:1.75';
          } else if (window.matchMedia('(max-width: 1024px)').matches) {
            aspectRatio = '4:3.75';
          }

          this.player = new Plyr(this.playerElement, {
            controls: [],
            ratio: aspectRatio,
            youtube: {
              noCookie: true,
              rel: 0,
              modestbranding: 1,
              showInfo: false,
            },
          });
          if (this.player) {
            this.player.on('ready', () => {
              setTimeout(() => {
                if (this.player) {
                  this.player.play();
                  this.isPlaying = true;
                }
              }, 50);
            });
          }
        }
      },
      openInYT() {
        if (this.playerElement) {
          const { id } = this.playerElement.dataset;
          if (id) {
            window.open(`https://www.youtube.com/watch?v=${id}`, '_blank');
          }
        }
      },
    }),
  );
}
